export default "__VITE_ASSET__BoVVm$3Y__"